import type { RouteRecordRaw } from "vue-router";
import Advertiser from "./modules/advertiser";
import Affiliate from "./modules/affiliate";
import Offer from "./modules/offer";
import Trade from "./modules/trade";
import Notification from "./modules/notification";
import Operation from "./modules/operation";
import System from "./modules/system";
import RiskControl from "./modules/riskControl";
import UpdownStream from "./modules/updownStream";
import Workbench from "./modules/workbench";
import OfferNew from "./modules/offerNew";
import Quotation from "./modules/quotation";
import Clue from "./modules/clue";

const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

/*
  key -> 对应的是 父级路由名 / 子级路由名
*/
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "/",
    redirect: "/home"
  },
  {
    path: "/login",
    name: "登录",
    component: () => import("@/views/Login/index.vue").catch(onError)
  },
  {
    path: "/:pathMatch(.*)",
    name: "不存在页面",
    meta: {
      key: "404"
    },
    component: () => import("@/components/Layout/index.vue").catch(onError),
    redirect: "/:pathMatch(.*)/not-found",
    children: [
      {
        name: "404",
        path: "/:pathMatch(.*)/not-found",
        component: () => import("@/views/NotFound/index.vue").catch(onError)
      }
    ]
  },
  {
    name: "首页",
    path: "/home",
    component: () => import("@/components/Layout/index.vue").catch(onError),
    meta: {
      key: "/home"
    },
    redirect: "/home/index",
    children: [
      {
        name: "Index",
        path: "index",
        component: () => import("@/views/Home/index.vue").catch(onError),
        meta: {
          key: "/home/index"
        }
      }
    ]
  }
];

export const routes: RouteRecordRaw[] = [
  Advertiser,
  Affiliate,
  Offer,
  OfferNew,
  Trade,
  Quotation,
  Notification,
  Operation,
  System,
  RiskControl,
  UpdownStream,
  Workbench,
  Clue
];

export default routes.concat(constantRoutes);
